import { categoryConfig } from '@/store/creative/common/category'

export default function getInitState() {
  return {
    templateConfig: null, // 模板配置
    id: '', // 模板配置中是模板 ID，制作页面中是版本 ID
    templateId: '', // 模板 ID
    customId: '', // 制作 ID
    skinId: '', // 皮肤 ID, 通用模板中才有皮肤
    page: '',
    version: 2, // 默认是 2
    isV2: true,
    isQcEngine: false,
    isCocosEngine: false,
    orientation: 1, // 横屏 2，竖屏 1
    device: 3, // 3: iPhone6

    // 是否可实时预览
    canLivePreview: false,
    // 是否有 json config
    hasJsonConfig: false,
    // 是否有模型资源
    hasModelResource: false,
    // 是否含有预设资源
    hasPresetResource: false,
    // 是否含有 cocos 模型
    hasCocosModel: false,
    // 是否是 mvPlayable 的版本，只有是 mvplayable 的版本才支持预览 cocos 项目模型
    hasMvPlayable: false,
    isLock: false,

    // 预览
    previewUrl: '', // 预览链接
    qrcodeUrl: '', // 二维码链接，为什么与预览链接分开，因为实时预览的时候不会触发重新生成预览链接，导致扫码看到的是内容不是最新的。如果生成二维码时更新 previewUrl 会重新去触发重新加载素材包（这个行为可能并不是用户需要的，因为可能只需要一个新的 qrcode）
    preparingPreview: false,
    currentLivePreviewResource: [], // 当前实时预览的资源

    // UI配置
    workSpaceSetting: {
      toolbar_isMuted: false, // 默认静音
      rightSideBar_isExpand: true, // 默认不折叠
    },

    // 是否是 dco 制作
    isDco: false,
    // 是否是多组合制作
    isMultiCustom: false,
    // 是否是通用模板制作
    isCommonTemplateCustom: false,
    // 是否模板编辑页面
    isTemplate: false,
    // 是否是通用模板模板制作，from 仓库后台
    isCommonTemplatePage: false,
    // 是否是定制模板模板制作，from PT
    isCreativeTemplateCustom: false,

    // 是否是通用模板制作, 包含 1. 通过url参数进入带templateType页面，2. 使用通用模板制作的项目， 3. 模板编辑页
    isGeneralTemplateService: false,

    /**
     * {**: {id: number, name: string, is_show: boolean}}
     */
    categoryConfig: {},

    validateList: [], // 页面验证列表
    dcoValidator: null,

    gameDifficulty: '',
    difficultyList: [
      {
        value: 'easy',
        label: '简单',
      },
      {
        value: 'medium',
        label: '中等',
      },
      {
        value: 'hard',
        label: '困难',
      },
    ],

    activeCategoryId: 0,
    activeCategoryNode: {},
    activeLanguageId: 0,

    currentCategory: null,

    cloudResourcesDialog: {
      visible: false,
    },

    addRepositoryResourceDialog: {
      visible: false,
      action: 'add',
    },

    addLocalResourceDialog: {
      visible: false,
      action: 'add',
    },

    currentResourceInZip: null,
    addLocalResourceInZipDialog: {
      visible: false,
    },
    menuTransferDialog: {
      visible: false,
    },
    sortMenuDialog: {
      visible: false,
    },
    currentResource: null,
    currentResourceGroupTop: 0,
    editResourceDialog: {
      closable: true,
      visible: false,
    },

    // 不在玩法 tab 下的 gameConfig 配置
    gameConfigResource: {},
    // 不在语言配置大分类下的 i18n 配置
    i18nResource: {},

    // 权限 key，将功能点抽象为 key，在进入该页面时全局统一生产出 key 列表
    permissions: [],

    // 当前语言，如代码字中或图片语言包中选择的语言，非预览语言
    currentLanguage: '',
    // 当前预览语言
    previewLanguage: '',
    previewLanguageList: [],

    zipLangList: '',

    // originalJson 包原始的 json 配置
    originalJson: null,
    originalResources: null,

    // 保存
    saving: false,
    saved: false,
    autoSaveTimeId: 0,
    // 模板状态，枚举值包括：saving 保存中 saved-successfully 保存成功 editing 编辑中
    templateState: 'editing',

    router: null,

    // dco 发布
    dcoPublishing: false,
    // custom 发布
    customPublishing: false,

    // 收藏
    starsConfig: {},
    foldCategoryList: [
      categoryConfig.elementStars.id,
      categoryConfig.gameConfigStars.id,
    ],

    // 组别配置
    // https://confluence.mobvista.com/pages/viewpage.action?pageId=47087938
    groupsConfig: [],
    // 预览组
    previewGroup: '',
    previewGroupConfig: null,

    outline: {
      category: [],
    },

    currentTab: 1, // 1 元素， 3 玩法

    // playable 开发预览使用的页面
    isPreviewBasicPackage: false,
    templateType: '', // 开发预览时的模版类型， gm 代表通用模板
    basicId: 0,
    // 是否只读
    isReadonly: false,
    // 当前项目绑定的需求信息
    bind_demand: {
      id: 0, // 需求ID
      status: 0, // 需求状态
      submit_status: 0, // 最后一次提测状态
    },
    refreshCover: '', // 需要刷新的封面图，传参 resource id
  }
}
